<template>
  <!-- "This device has had its free reading" (mystic-page 2026-10-29,
       OUTLINE decision 4; API.md §4; prototype `used`): a sheet from the
       bottom. Reveal Myself is the way on. -->
  <div class="fru-veil" data-testid="free-reading-used" @click.self="$emit('close')">
    <div class="fru" role="dialog" aria-modal="true" aria-labelledby="fru-h">
      <img v-if="portrait" class="fru-pt" :src="portrait" alt="" />
      <h2 id="fru-h" class="fru-h">{{ title }}</h2>
      <p class="fru-body">Reveal yourself to keep going with {{ name }}. Your first reading on your own account is on us.</p>
      <button type="button" class="fru-btn" data-testid="free-reading-reveal" @click="$emit('reveal')"><span aria-hidden="true">✦</span> Reveal Myself</button>
      <p v-if="price" class="fru-price">Readings with {{ name }} are {{ price }} after your first.</p>
    </div>
  </div>
</template>

<script setup>
defineProps({
  name: { type: String, default: 'this Mystic' },
  portrait: { type: String, default: '' },
  price: { type: String, default: '' },
  // The server's own line (API.md §4), else the moment's title.
  title: { type: String, default: 'This device has had its free reading' },
})
defineEmits(['reveal', 'close'])
</script>

<style scoped>
.fru-veil { position: fixed; inset: 0; z-index: 3000; display: flex; align-items: flex-end; justify-content: center; background: rgba(6, 2, 14, 0.62); }
.fru { width: 100%; max-width: 520px; box-sizing: border-box; padding: 26px 24px calc(22px + env(safe-area-inset-bottom, 0px)); border-radius: 26px 26px 0 0;
  background: #faf5ea; color: #2a1648; text-align: center; animation: fru-up .32s cubic-bezier(.2,.9,.3,1) both; }
@media (min-width: 700px) { .fru-veil { align-items: center; } .fru { border-radius: 24px; } }
.fru-pt { width: 56px; height: 56px; border-radius: 12px; object-fit: cover; border: 1px solid rgba(42, 22, 72, .2); }
.fru-h { margin: 12px 0 8px; font: 600 28px/1.15 'Cormorant Garamond', Georgia, serif; color: #2a1648; }
.fru-body { margin: 0 0 18px; font: 500 15px/1.5 'Inter', system-ui, sans-serif; color: #5b4a7a; }
.fru-btn { width: 100%; min-height: 50px; border: 0; border-radius: 999px; cursor: pointer; font: 700 17px 'Inter', system-ui, sans-serif; color: #ffe7b5;
  background: linear-gradient(180deg, #7b4bb0, #4e2776); box-shadow: 0 10px 24px -12px rgba(78, 39, 118, .9); }
.fru-btn:focus-visible { outline: 2px solid #c9a94e; outline-offset: 3px; }
.fru-price { margin: 14px 0 0; font: 500 13px 'Inter', system-ui, sans-serif; color: #7a6a96; }
@keyframes fru-up { from { transform: translateY(24px); opacity: 0; } }
@media (prefers-reduced-motion: reduce) { .fru { animation: none; } }
</style>
